export interface IsMobileProps {
  isMobile: boolean;
}

export enum CatalogueType {
  Current = 'current',
  Next = 'next',
}

export interface CatalogueProps {
  url?: string | undefined;
  title?: string | undefined;
  imageUrl?: string | undefined;
  validity: string | null;
}

export interface CurrentCatalogueProps {
  isMobile: boolean;
  onClick: () => void;
  catalogue: CatalogueProps;
  linkToAllCatalogues: string;
}

export interface NextCatalogueProps {
  onClick: () => void;
  catalogue: CatalogueProps;
}
